import React from 'react';
import styled from 'styled-components';
import { CPanel } from '@appcues/component-library';
import Loader from 'components/Common/Loader';
import BreakoutGraph from 'components/SatisfactionSurveys/SatisfactionSurveysIndex/Dashboard/BreakoutGraph';
import BucketGraph from 'components/SatisfactionSurveys/SatisfactionSurveysIndex/Dashboard/BucketGraph';
import KeyMetrics from 'components/SatisfactionSurveys/SatisfactionSurveysIndex/Dashboard/KeyMetrics';
import SatisfactionFeedback from 'components/SatisfactionSurveys/SatisfactionSurveysIndex/Dashboard/SatisfactionFeedback';
import { SAMPLE_METRICS } from 'constants/satisfaction/data';

const SatisfactionSurveysDashboard = ({
  currentModal,
  resultsSynced,
  firebaseSynced,
  isNPSProductTrialExpired,
  className,
  promoters,
  neutrals,
  detractors,
  shownCount,
  qualitativeCount,
  responseCount,
  npsScore,
  responsesByScore,
}) => {
  const state = currentModal
    ? {
        promoters: SAMPLE_METRICS.buckets.promoters,
        neutrals: SAMPLE_METRICS.buckets.neutrals,
        detractors: SAMPLE_METRICS.buckets.detractors,
        shownCount: SAMPLE_METRICS.shownCount,
        qualitativeCount: SAMPLE_METRICS.qualitativeCount,
        responseCount: SAMPLE_METRICS.responseCount,
        npsScore: SAMPLE_METRICS.npsScore,
        responsesByScore: SAMPLE_METRICS.responsesByScore,
      }
    : {
        promoters,
        neutrals,
        detractors,
        shownCount,
        qualitativeCount,
        responseCount,
        npsScore,
        responsesByScore,
      };

  const shouldHideDashboard =
    firebaseSynced && (isNPSProductTrialExpired || currentModal);

  if (!resultsSynced) {
    return <Loader />;
  }
  if (shouldHideDashboard) {
    return <div />;
  }

  return (
    <CPanel>
      <div className={`dashboard ${className}`}>
        <div className="page-container">
          <KeyMetrics
            npsScore={state.npsScore}
            responseCount={state.responseCount}
            qualitativeCount={state.qualitativeCount}
            shownCount={state.shownCount}
          />
        </div>

        <div className="page-container graphs">
          <BreakoutGraph
            promoters={state.promoters}
            neutrals={state.neutrals}
            detractors={state.detractors}
            responseCount={state.responseCount}
          />
          <BucketGraph responsesByScore={responsesByScore} />
        </div>

        <hr className="table-divider" />

        <SatisfactionFeedback className="page-container" />
      </div>
    </CPanel>
  );
};

export default styled(SatisfactionSurveysDashboard)`
  .graphs {
    display: flex;
    justify-content: flex-start;
    margin: 2rem 0 3rem;
    padding: 0 4rem;
  }

  hr {
    width: 100%;
    margin: 0;
    border: 1px solid ${props => props.theme['$gray-1']};

    &.table-divider {
      margin: 30px 0;
    }
  }
`;
